import * as types from "../action/ActionType";
import {  USER_LIST_INITIAL } from "../store/InitialStore";
export default function AllUserReducer(state = USER_LIST_INITIAL, action) {
  const { type, payload } = action;
  switch (type) {
    case types.USER_LIST_TYPE:
      return (state = payload);
    default:
      return state;
  }
}
